var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('image-gallery',_vm._g({attrs:{"images":_vm.images}},_vm.$listeners)),_c('infinite-loading',{on:{"infinite":_vm.onLoadMore}}),_c('div',{staticClass:"h-24"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }